/* eslint-disable no-underscore-dangle */
import React, { forwardRef } from 'react'
import { Flex, GetRef, Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { useUseJiraRequestTypes } from '../queries/useJiraRequestTypes'

type SelectRefType = GetRef<typeof Select>

const JiraRequestTypeSelect = forwardRef<SelectRefType, Omit<SelectProps, 'options'>>((props, ref) => {
  const { t } = useTranslation()
  const { data: jiraRequestTypes, isFetching: jiraRequestTypesFetching } = useUseJiraRequestTypes()

  const options = jiraRequestTypes?.map(requestType => ({
    value: requestType.id,
    label: (
      <Flex align="center" gap={8}>
        <img style={{ height: '1rem' }} src={requestType.icon._links.iconUrls['16x16']} alt="icon" />
        <span>{t(`jiraRequestType:${requestType.id}`)}</span>
      </Flex>
    )
  }))

  return <Select ref={ref} loading={jiraRequestTypesFetching} options={options} {...props} />
})

export default JiraRequestTypeSelect
